function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import PropTypes from "prop-types";
import { Avatar } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
function GroupAvatar(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    group = _ref.group,
    className = _ref.className,
    style = _ref.style,
    onClick = _ref.onClick;
  var width, height, fontSize;
  if (size === "xs") {
    width = 25;
    height = 25;
    fontSize = 12;
  } else if (size === "sm") {
    width = 33;
    height = 33;
    fontSize = 18;
  } else if (size === "md") {
    width = 40;
    height = 40;
    fontSize = 20;
  } else if (size === "lg") {
    width = 80;
    height = 80;
    fontSize = 40;
  } else if (size === "xl") {
    width = 150;
    height = 150;
    fontSize = 64;
  } else {
    throw new Error("Size not supported.");
  }
  return group.picture ? /*#__PURE__*/React.createElement(Avatar, {
    src: group.picture.src
    // onError={({ currentTarget }) => {
    //   currentTarget.onerror = null
    //   currentTarget.src = "/img/image_missing.png"
    // }}
    ,
    className: className,
    style: _objectSpread({
      width: width,
      height: height
    }, style),
    onClick: onClick
  }) : /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-circle",
    style: {
      width: width,
      height: height
    },
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: className,
    style: {
      color: "#fff",
      width: width,
      height: height,
      fontSize: fontSize
    },
    onClick: onClick
  }, /*#__PURE__*/React.createElement(GroupIcon, null)));
}
export default GroupAvatar;
GroupAvatar.defaultProps = {
  size: "md"
};
GroupAvatar.propTypes = {
  group: PropTypes.object.isRequired,
  size: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
};